import { gql } from '@apollo/client';

export const GET_COACH_DASHBOARD = gql`
  query GetCoachDashboard {
    getCoachDashboard {
      coach {
        _id
        firstName
        lastName
        organization
        profilePicture
      }
      athletes {
        _id
        firstName
        lastName
        sports
        team
        profilePicture
      }
      assessments {
        _id
        type
        sport
        level
        passed
        scorePercent
        gScore
        etsTraitScores {
          focus
          resilience
          discipline
          coachability
          competitiveness
        }
        dateTaken
        profile
        confidence
        blend
      }
    }
  }
`;

export const VIEW_ATHLETE = gql`
  query ViewAthlete($athleteId: ID!) {
    viewAthlete(athleteId: $athleteId) {
      athlete {
        _id
        firstName
        lastName
        sports
      }
      assessments {
        _id
        type
        sport
        level
        passed
        scorePercent
        gScore
        etsTraitScores {
          focus
          resilience
          discipline
          coachability
          competitiveness
        }
        profile
        confidence
        blend
        dateTaken
      }
    }
  }
`;

export const GET_COACH_ATHLETES_WITH_ASSESSMENTS = gql`
  query GetCoachAthletesWithAssessments($sport: String!) {
    getCoachAthletesWithAssessments(sport: $sport) {
      athlete {
        _id
        firstName
        lastName
        sports
        team
      }
      latestETSAttempt {
        _id
        gScore
        etsTraitScores {
          focus
          resilience
          discipline
          coachability
          competitiveness
        }
        dateTaken
      }
      latestTraitAttempt {
        _id
        profile
        confidence
        blend
        dateTaken
      }
      highestScoreByLevel {
        level
        scorePercent
      }
    }
  }
`;

//still need to add new trait quiz display for Coach and Coaches Athletes